import React from 'react'

export type TRefreshMyProfileProps = {
    urlRefresh: string
    token: string
    userId: number
    loadingRefresh: boolean
    setLoadingRefresh: (isLoading: boolean) => void
    trans: (key: string) => string
}

export type TMakeProfileSearchableProps = {
    urlRefresh: string
    loadingSearchable: boolean
    setLoadingSearchable: React.Dispatch<boolean>
    trans: (value: any) => string
}

export type TInputGroupProps = {
    max: number
    prefixText: string
    placeholder: string
    isInputCompanyName: boolean
    isMobile: boolean
    trans: (key: string) => string
    userToken: string
}

export type THideMyProfileProps = {
    trans: (key: string) => string
}

export enum ERefreshProfile {
    Unset = 0,
    Daily = 1,
    Weekly = 2
}
